import instance from "../../utils/axios";

// ✅ Fetch Resources
export const fetchResources = async (_id) => {
  const formData = new URLSearchParams();
  if (_id) formData.append("_id", _id);

  const response = await instance.post("/churches/resources/read", formData);
  return response.data;
};

// ✅ Save Resource
export const saveResource = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/resources/save", formData);
  return response.data;
};

// ✅ Update Resource
export const updateResource = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/resources/update", formData);
  return response.data;
};

// ✅ Delete Resource
export const deleteResource = async ({ _id, resourceObjId }) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);
  formData.append("resourceObjId", resourceObjId);

  const response = await instance.post("/churches/resources/delete", formData);
  return response.data;
};
